<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import SessionTranscription from "@/components/Session/SessionTranscription.vue";

export default {
    name: "QuotesModalTranscription",
    components: {
        SessionTranscription,
        AjaxLoad,
    },
    props: {
        idSession: {
            type: Number,
        },
        idProject: {
            type: String,
        },
        time: {
            type: Number,
        },
    },
    methods: {
        rewind() {
            this.$refs.sessionTranscription?.rewind(1000);
        },
    },
}
</script>

<template>
    <ajax-load
        v-if="idProject && idSession"
        :url="$apiUrl.getSessionUrl({id_project: idProject, id: idSession})"
        :transform="response => response.data.data"
        v-slot="{data}"
    >
        <session-transcription
            ref="sessionTranscription"
            :session="data"
            :time="time"
        ></session-transcription>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>